(() => {
  const root = document.querySelector('[data-model-product]');
  if (!root) return;
  const fi = document.documentElement.lang.startsWith('fi');
  const icon = (path, size = 20) => `<svg viewBox="0 0 20 20" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${path}"/></svg>`;
  const expand = root.querySelector('.pdp-collapse-toggle');
  if (expand) {
    const sync = () => {
      const open = expand.getAttribute('aria-expanded') === 'true';
      expand.innerHTML = `<span>${open ? (fi ? 'Supista' : 'Collapse') : (fi ? 'Laajenna' : 'Expand')}</span>` + icon(open ? 'M4 12l6-6 6 6' : 'M4 8l6 6 6-6', 16);
    };
    new MutationObserver(sync).observe(expand, { attributes: true, attributeFilter: ['aria-expanded'] });
    sync();
  }
  const arrow = direction => icon(direction < 0 ? 'M16 10H4m5-5-5 5 5 5' : 'M4 10h12m-5-5 5 5-5 5');
  root.querySelectorAll('.pdp-similar-arrow').forEach(button => { button.innerHTML = arrow(Number(button.dataset.relatedStep)); });
  const similarSlider = root.querySelector('.pdp-similar-slider');
  const similarPhoto = similarSlider?.querySelector('.pdp-similar-photo');
  if (similarPhoto) {
    const centreArrows = () => {
      const photo = similarPhoto.getBoundingClientRect();
      const slider = similarSlider.getBoundingClientRect();
      similarSlider.style.setProperty('--similar-image-centre', `${photo.top - slider.top + photo.height / 2}px`);
    };
    new ResizeObserver(centreArrows).observe(similarPhoto);
    centreArrows();
  }
  const track = root.querySelector('.pdp-thumbnails');
  if (!track || track.children.length < 2) return;
  const slider = document.createElement('div');
  slider.className = 'gastro-thumbnail-slider';
  track.before(slider); slider.append(track);
  const buttons = [-1, 1].map(direction => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gastro-thumbnail-arrow ' + (direction < 0 ? 'prev' : 'next');
    button.setAttribute('aria-label', direction < 0 ? (fi ? 'Edelliset kuvat' : 'Previous images') : (fi ? 'Seuraavat kuvat' : 'Next images'));
    button.innerHTML = arrow(direction);
    button.onclick = () => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    slider.append(button); return button;
  });
  const sync = () => {
    const overflow = track.scrollWidth > track.clientWidth + 2;
    buttons[0].hidden = !overflow || track.scrollLeft <= 2;
    buttons[1].hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  track.addEventListener('scroll', sync, {passive: true});
  track.addEventListener('focusin', event => {
    const button = event.target.closest('[data-product-image]');
    if (!button) return;
    const rect = button.getBoundingClientRect(), bounds = track.getBoundingClientRect();
    if (rect.left < bounds.left) track.scrollBy({left: rect.left - bounds.left});
    else if (rect.right > bounds.right) track.scrollBy({left: rect.right - bounds.right});
  });
  new ResizeObserver(sync).observe(track);
  sync();
})();
